<template>
  <div>
      <numeric-range-params-template :filter="filter"/>
  </div>
</template>
<script>
  import NumericRangeParamsTemplate from '@/components/wdc/params/numeric-range-params-template'

  export default {
    components: {
      NumericRangeParamsTemplate
    },
    props: {
      filter: Object
    },
    name: 'aviationRankRangeParams'
  }
</script>
<style>
</style>
